import * as Types from '../../../../types/schema.generated';

import gql from 'graphql-tag';
export type SegmentFormFragment = { __typename?: 'Query', segmentConditionParameters: { __typename?: 'SegmentConditionParameters', enqueteAnsweredCondition: { __typename?: 'SegmentConditionParameter_EnqueteAnswered', enquetes: Array<{ __typename?: 'SegmentConditionParameter_EnqueteAnswered_Enquete', guid: string, title: string }> }, inflowSourceCondition: { __typename?: 'SegmentConditionParameter_InflowSource', inflowSources: Array<{ __typename?: 'UserRegistrationInflowSourceDefinition', guid: string, inflowSourceName: string }> }, clickURLCondition: { __typename?: 'SegmentConditionParameter_ClickURL', clickUrls: Array<{ __typename?: 'SegmentConditionParameter_ClickURL_URL', guid: string, url: string }> }, userVariableDefinitionCondition: { __typename?: 'SegmentConditionParameter_UserVariableDefinition', userVariableDefinitions: Array<{ __typename?: 'UserVariableDefinition', guid: string, name: string, value: { __typename: 'UserVariableDefinitionValueMultipleSelect', options: Array<{ __typename?: 'UserVariableDefinitionValueSelectOption', guid: string, name: string }> } | { __typename: 'UserVariableDefinitionValueSelect', options: Array<{ __typename?: 'UserVariableDefinitionValueSelectOption', guid: string, name: string }> } | { __typename?: 'UserVariableDefinitionValueString' } | { __typename?: 'UserVariableDefinitionValueText' } }> } } };

export const SegmentFormFragmentDoc = gql`
    fragment SegmentForm on Query {
  segmentConditionParameters {
    enqueteAnsweredCondition {
      enquetes {
        guid
        title
      }
    }
    inflowSourceCondition {
      inflowSources {
        guid
        inflowSourceName
      }
    }
    clickURLCondition {
      clickUrls {
        guid
        url
      }
    }
    userVariableDefinitionCondition {
      userVariableDefinitions {
        guid
        name
        value {
          ... on UserVariableDefinitionValueSelect {
            __typename
            options {
              guid
              name
            }
          }
          ... on UserVariableDefinitionValueMultipleSelect {
            __typename
            options {
              guid
              name
            }
          }
        }
      }
    }
  }
}
    `;